// 完了画面から案内する「メールが届かない場合の対処方法について」FAQ URL
export const MAIL_NOT_DELIVERED_COLUMN_URL =
  'https://tayori.com/q/travelist/detail/1236155/';

// ホテル完了画面の連絡先メールアドレスを同一タブ内で引き渡すための sessionStorage キー
export const HOTEL_COMPLETE_EMAIL_STORAGE_KEY = 'hotelCompleteEmail';

// SPA の申込完了画面（航空券・ホテル）だけで使うメールアドレス誤りの案内。
// レガシーの決済完了画面は同趣旨の文言を各配列に直接持つため、ここは共有していない。
export const MAIL_ADDRESS_NOTE =
  '入力されたメールアドレスに間違いがあった場合、メールが届かず、航空券・ホテルが手配できない場合があります。必ずメールをご確認ください。';

// 迷惑メールフォルダの案内。SPA の申込完了画面（航空券・ホテル）とレガシーの
// 決済完了画面（PAYMENT_FLIGHT_NOTES / HOTEL_NOTES）が共有する唯一の文言で、
// 片方だけ変えて食い違わないよう定数にしている。変更は全画面に効く。
// 文字列中の \n は改行として描画される（CompleteContactInfo の li が white-space: pre-line）。
export const SPAM_FOLDER_NOTE =
  '弊社からのご連絡メールが「迷惑メールフォルダ」に届く恐れがあります。\n3分程経過いたしましても弊社からのメールがご確認できない場合は、お手数ですが「迷惑メールフォルダ」をご確認いただくようお願い申し上げます。万が一、迷惑メールフォルダにも弊社からのメールが届いていない場合は、弊社までご連絡くださいませ。';

// 決済状況ポーリングの打ち切り時間。ApplicationComplete.vue の checkPayable() の
// ループ上限と、CompletePaymentStatus の進捗バーの所要時間の両方で参照する。
// 片方だけ変えるとバーの進みが実際の待ち時間と合わなくなる。
export const PAYMENT_POLLING_DURATION_MS = 10000;

// レガシー決済完了画面（ホテル単体）の注意事項。src_legacy から
// data-tvl-notes-kind="hotel" で参照する。
export const HOTEL_NOTES = [
  SPAM_FOLDER_NOTE,
  '入力されたメールアドレスに間違いがあり、メールが届かない場合、予約情報の確認ができない恐れがございますので必ずメールをご確認ください。',
];

// 決済完了画面（card/GMO系/Paidy等）専用の注意事項。
// 申込完了画面の注意事項（ApplicationComplete.vue の FLIGHT_NOTES）は入金前提の
// 文言のため、決済完了画面に転用すると「振込み明細」「ご購入期限」「価格が変更」等、
// 支払い済みの状態と矛盾する記述になる（PR #1561レビュー指摘）。決済完了直後の
// 文脈に合う項目は残し、矛盾するものを除外している。base版(Figma適用前の
// card_transaction_do.html、git show 5f97741ed^)にあった保険関連の案内（保険加入の
// 所要日数・引受保険会社名・未加入時の再申込案内・受取番号案内のSLA）を復元する。
// 冒頭の決済完了メールの案内は事業部確認済み。他の項目は事業/法務側での最終確認が
// 別途予定されている（Linear参照）。
export const PAYMENT_FLIGHT_NOTES = [
  'ご購入手続きが完了次第、順次決済完了メールをお送りいたします。',
  '決済完了メールを送付後、順次ご搭乗に必要な受取番号をメール又はFAXにてご案内いたします。発券手続きの関係で、受取番号のご案内は決済完了メール送付日の21時以降から2営業日以内となります。',
  SPAM_FOLDER_NOTE,
  '入力されたメールアドレスに間違いがあり、メールが届かない場合、航空券・ホテルが手配できない場合がありますので必ずメールをご確認ください。',
  // TODO: 以下の保険関連の案内（加入手続きの所要日数・航空券手配不成立時の案内）は、
  // 保険を含む予約でのみ表示したい。今回は見送り。
  // 判定には insurance_chubb::get_insurance_data() を使う（既定の対象は
  // ins_result_status_cd IN (2,3,5) = お申込み有効・確定・失敗）。
  // 同クラスの has_insurance_data() は対象が IN (1,4) = 仮・予約待ち のため、
  // 加入確定後に false となり決済完了画面の判定には使えない。
  // 実施時の検討事項: insurances は DSN_TRAVEL（本サイトとは別DB）にあり
  // 描画ごとにクエリが1回増えること、加入失敗（status 5）でも出すかどうか。
  '旅行保険は手配および決済完了後に加入手続き処理を行いますので、処理完了まで最大2日ほど要する場合がございます。処理完了後にご案内のメールを引受保険会社（Chubb損害保険株式会社）から送付いたします。',
  '航空券手配ができなかった場合は保険加入登録もされません。その際は再度航空券を手配する際に保険申込をお願いいたします。',
];
